export const state = () => ({
  // CAD, USD, EUR
  currency: null,
})

export const getters = {
  getCurrency: (state) => state.currency,
}

export const mutations = {
  setCurrency(state, currency) {
    state.currency = currency
  },
}

export const actions = {
  async initialize({ commit }) {
    try {
      const currency = this.app.$cookies.get('lole-currency') || 'CAD'
      commit('setCurrency', currency)
      await this.app.$cookies.set('lole-currency', currency, {
        maxAge: 60 * 60 * 24 * 30,
        path: '/',
      })
    } catch (e) {
      this.app.$cookies.remove('lole-currency')
    }
  },
  async switchCurrency({ commit }, currency) {
    await this.app.$cookies.set('lole-currency', currency, {
      maxAge: 60 * 60 * 24 * 30,
      path: '/',
    })
    commit('setCurrency', currency)
    window.location.reload()
  },
}
